import acrobat from '../../../../assets/variants/acrobat.gif';
import active_directory from '../../../../assets/variants/active_directory.gif';
import adobe from '../../../../assets/variants/adobe.png';
import atlassian from '../../../../assets/variants/atlassian.png';
import aws from '../../../../assets/variants/aws.png';
import chrome from '../../../../assets/variants/chrome.svg';
import excel from '../../../../assets/variants/excel.gif';
import gmail from '../../../../assets/variants/gmail.gif';
import google from '../../../../assets/variants/google.png';
import internet_explorer from '../../../../assets/variants/internet_explorer.png';
import manage_engine from '../../../../assets/variants/manage_engine.gif';
import microsoft_outlook from '../../../../assets/variants/microsoft_outlook.png';
import mssql from '../../../../assets/variants/mssql.png';
import mysql from '../../../../assets/variants/mysql.png';
import oracle from '../../../../assets/variants/oracle.png';
import postgresql from '../../../../assets/variants/postgresql.png';
import salesforce from '../../../../assets/variants/salesforce.png';
import sap from '../../../../assets/variants/sap.png';
import slack from '../../../../assets/variants/slack.png';
import word from '../../../../assets/variants/word.gif';
import _4me from '../../../../assets/variants/4me.png';

export default {
    'Acrobat': acrobat,
    'Active Directory': active_directory,
    'Adobe': adobe,
    'Atlassian': atlassian,
    'AWS': aws,
    'Chrome': chrome,
    'Excel': excel,
    'Gmail': gmail,
    'Google': google,
    'Internet Explorer': internet_explorer,
    'Manage Engine': manage_engine,
    'Outlook': microsoft_outlook,
    'MsSQL': mssql,
    'MySQL': mysql,
    'Oracle': oracle,
    'PostgreSQL': postgresql,
    'Salesforce': salesforce,
    'SAP': sap,
    'Slack': slack,
    'Word': word,
    '4me': _4me
}
